// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3836":"af737704","3938":"af737704","6294":"9363fa2e","8236":"59bbd4e4","9767":"b353d70f"}[chunkId] + ".chunk.css";
};